import { render, staticRenderFns } from "./NavigationDrawerItems.vue?vue&type=template&id=4aba64c2&scoped=true&"
import script from "./NavigationDrawerItems.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawerItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba64c2",
  null
  
)

export default component.exports